export enum StackType{
    card,
    cube
}


// WEBPACK FOOTER //
// ./src/app/Model/StackType.ts